




































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Category from './category';
import _ from 'lodash';

@Component
export default class extends Vue {
  @Prop() category : Category;

  deleteDialog = false;

  search = '';

  dialog = false;
  valid = true;
  editedIndex = -1;

  editedItem = {
    id: -1,
    name: "",
  };

  defaultItem = {
    id: -1,
    name: "",
  };

  nameRules = [
    v => !!v || 'This field is required',
    v => this.checkUniqueName(v),
  ];

  requiredNumberRules = [
    v => typeof(v) == 'number' || 'This field is required',
  ];

  checkUniqueName(name) {
    if (this.editedIndex != -1)
      return true;

    if (name == null)
      return false;

    const found = this.category.values.some( category => category.name.toLowerCase() === name.toLowerCase() );
    return !found || this.category.name + ' already exists';
  }

  get formTitle () {
    return this.editedIndex === -1 ? 'New ' + this.category.name.toLowerCase() : 'Edit ' + this.category.name.toLowerCase();
  }

  editItem(item) {
    this.editedIndex = this.category.values.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  close() {
    this.dialog = false;

    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300)
  }

  save() {
    const form = this.$refs.form as any;
    if (!form.validate()) {
      return;
    }

    if (this.editedIndex > -1) {
      this.editValue();
    } else {
      this.createValue();
    }

    this.close();
  }

  closeDelete() {
    this.deleteDialog = false;
  }

  createValue() {
    const input = _.omit(this.editedItem, ['__typename', 'id']);
    this.category.create(this.$apollo, input);
  }

  editValue() {
    const input = _.omit(this.editedItem, ['__typename']);
    this.category.edit(this.$apollo, input, this.editedItem.id);
  }

  deleteValue() {
    this.category.delete(this.$apollo, this.editedItem.id);

    this.closeDelete();
    this.close();
  }

  @Watch('dialog')
  onDialogChange(val) {
    if (!val)
      this.close();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/tables/CategoryTable.vue